<template>
    <el-dialog
        class="conclusion"
        :visible.sync="conclusionVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="会议总结"
    >
        <div class="container">
            <div class="formCont">
                <el-row>
                    <el-col :span="12" v-if="msg.is_custom_room == 1">
                        <div class="label">公司会议室：</div>
                        <div class="content">{{ msg.address_name }}</div>
                    </el-col>
                    <el-col :span="12" v-else>
                        <div class="label">自定义地点：</div>
                        <div class="content">{{ msg.address_name }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">会议时间：</div>
                        <div class="content">
                            {{ msg.meeting_date }}
                            {{ msg.meeting_start_time }} 至
                            {{ msg.meeting_end_time }}
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">参会人：</div>
                        <div class="content">{{ msg.conferee_cn }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">主持人：</div>
                        <div class="content">{{ msg.user_name }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">会议主题：</div>
                        <div class="content">{{ msg.title }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="label">会议内容：</div>
                        <div class="content">
                            <!-- <vue-tinymce
                                v-if="conclusionVisible"
                                v-model="msg.content"
                                :setting="setting"
                            /> -->
                            <el-input
                                type="textarea"
                                placeholder="会议内容"
                                size="small"
                                v-model="msg.content"
                                :autosize="{ minRows: 10, maxRows: 12 }"
                            >
                            </el-input>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="label">会议总结：</div>
                        <div class="content">
                            <el-form ref="form" :model="msg">
                                <el-form-item
                                    :rules="[
                                        {
                                            required: true,
                                            message: '请输入总结',
                                        },
                                    ]"
                                    prop="summary"
                                >
                                    <!-- <vue-tinymce
                                        v-if="conclusionVisible"
                                        v-model="msg.summary"
                                        :setting="conclusionSetting"
                                    /> -->
                                    <el-input
                                        type="textarea"
                                        placeholder="会议总结"
                                        size="small"
                                        v-model="msg.summary"
                                        :autosize="{ minRows: 10, maxRows: 12 }"
                                    >
                                    </el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >保存</el-button
            >
            <el-button size="small" @click="conclusionVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";
import { mapState } from "vuex";
export default {
    data() {
        return {
            msg: {
                summary: "",
            },
        };
    },
    props: {
        conclusionVisible: Boolean,
        tableItem: Object,
    },
    watch: {
        conclusionVisible: {
            handler(newValue) {
                if (newValue) {
                    this.meetingList();
                }
            },
        },
    },
    created() {},
    methods: {
        /**
         * 保存
         */
        save() {
            this.$refs["form"].validate((valid) => {
                console.log(valid);
                if (valid) {
                    let { id, summary } = this.msg;
                    oaApi
                        .meetingSummary({ summary, id }, "post")
                        .then((res) => {
                            if (res) {
                                this.$parent.meetingList();
                                this.closeDialog();
                                this.$message.success("总结成功!");
                            }
                        });
                }
            });
        },
        /**
         * 关闭对话框
         */
        closeDialog() {
            this.$emit("update:conclusionVisible", false);
            this.msg.summary = "";
        },
        meetingList() {
            oaApi.meetingList({}, "get", this.tableItem.id).then((res) => {
                //console.log(res);
                if (res.code == 200) {
                    this.msg = res.data;
                }
            });
        },
    },
    components: {},
    computed: {
        ...mapState({
            setting: (state) =>
                Object.assign(JSON.parse(JSON.stringify(state.index.setting)), {
                    readonly: true,
                }),
            conclusionSetting: (state) => state.index.setting,
        }),
    },
};
</script>

<style lang="scss" scoped>
.conclusion {
    .el-dialog__body {
        padding: 20px 40px;
    }
    .el-select,
    .el-date-editor {
        width: 100%;
    }
    .el-form-item {
        .el-form-item__content {
            .el-radio {
                margin: 0;
                width: 100px;
            }
        }
    }
    .container {
        margin-top: 10px;
        .formCont {
            padding: 13px 0;
            .el-row {
                margin-bottom: 10px;
                .el-col {
                    display: flex;
                    min-height: 30px;
                    align-content: center;
                    justify-content: center;
                    font-size: 13px;
                    line-height: 2;
                    .label {
                        font-size: 12px;
                        width: 120px;
                        text-align: right;
                    }
                    .content {
                        width: 100%;
                        width: calc(100% - 120px);
                        text-align: left;
                    }
                    .link {
                        color: $theme-color;
                        text-decoration: underline;
                        cursor: pointer;
                        user-select: none;
                        &:hover {
                            opacity: 0.6;
                        }
                        &:active {
                            opacity: 0.8;
                        }
                    }
                    .priority {
                        margin: 0;
                    }
                    .comment-list {
                        padding-left: 50px;
                        text-align: left;
                        width: 100%;
                        margin-bottom: 10px;
                        .cl-title {
                            padding-left: 10px;
                        }
                        .cl-content {
                            background: #f9f9f9;
                            border: 1px solid #eeeeee;
                            border-radius: 2px;
                            padding: 2px 10px;
                        }
                    }
                }
                .el-col-24 {
                    justify-content: flex-start;
                    align-content: center;
                    .label {
                        width: 120px;
                    }
                    .content {
                        width: 100%;
                        width: calc(100% - 120px);
                        text-align: left;
                    }
                }
                // border-bottom: 1px #e8e8e8 solid;
                .el-image {
                    width: 120px;
                }
            }
        }
    }
}
</style>
